var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlower(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 348.468,
    height: 216.955,
    viewBox: "0 0 348.468 216.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10855",
    "data-name": "Group 10855",
    transform: "translate(0.001)",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44464",
    "data-name": "Path 44464",
    d: "M132.777,190.489a3.754,3.754,0,0,0,1.905-2.46c.531-2.273,12.776-56.18-11.233-102.652-24.022-46.5-74.556-66.64-76.7-67.476a3.744,3.744,0,0,0-5.007,2.636c-.533,2.27-12.778,56.178,11.231,102.652,24.022,46.5,74.556,66.64,76.7,67.473a3.709,3.709,0,0,0,1.361.256,3.749,3.749,0,0,0,1.743-.431M116.793,88.816c18.878,36.542,13.778,79.328,11.447,93.041-12.453-5.8-49.747-25.595-68.608-62.1C40.759,83.212,45.854,40.43,48.185,26.713c12.461,5.816,49.78,25.658,68.608,62.1",
    transform: "translate(41.982 19.417)",
    fill: "#f98309"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44465",
    "data-name": "Path 44465",
    d: "M87.392,189.476c2.18-.828,53.733-20.785,78.87-66.659,25.149-45.9,13.625-99.065,13.121-101.306a3.748,3.748,0,0,0-4.982-2.682c-2.18.828-53.735,20.785-78.87,66.659-25.15,45.9-13.623,99.065-13.123,101.306a3.746,3.746,0,0,0,4.984,2.682m72.3-70.258c-19.762,36.069-58.1,55.743-70.777,61.469-2.147-13.57-6.557-55.562,13.188-91.6,19.762-36.067,58.093-55.739,70.773-61.467,2.136,13.585,6.528,55.621-13.184,91.6M98.824,87.288h0Z",
    transform: "translate(87.302 20.451)",
    fill: "#f98309"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44466",
    "data-name": "Path 44466",
    d: "M87.392,189.476c2.18-.828,53.733-20.785,78.87-66.659,25.149-45.9,13.625-99.065,13.121-101.306a3.748,3.748,0,0,0-4.982-2.682c-2.18.828-53.735,20.785-78.87,66.659-25.15,45.9-13.623,99.065-13.123,101.306a3.746,3.746,0,0,0,4.984,2.682m72.3-70.258c-19.762,36.069-58.1,55.743-70.777,61.469-2.147-13.57-6.557-55.562,13.188-91.6,19.762-36.067,58.093-55.739,70.773-61.467,2.136,13.585,6.528,55.621-13.184,91.6M98.824,87.288h0Z",
    transform: "translate(87.302 20.451)",
    fill: "#f98309"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44467",
    "data-name": "Path 44467",
    d: "M173.434,147.517a3.746,3.746,0,0,0,2.308-5.131c-.962-2.119-24.125-52.147-71.407-73.764C57.029,47,4.844,62.611,2.647,63.287a3.744,3.744,0,0,0-2.31,5.131c.962,2.117,24.127,52.147,71.41,73.762,19.189,8.773,39.18,11.417,56.31,11.417a168.108,168.108,0,0,0,45.378-6.08m-98.573-12.15c-37.172-17-59.2-53.859-65.682-66.049,13.314-3.169,54.937-10.842,92.039,6.12,37.182,17,59.207,53.865,65.686,66.052-13.3,3.18-54.871,10.869-92.043-6.123",
    transform: "translate(0 62.946)",
    fill: "#f98309"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44468",
    "data-name": "Path 44468",
    d: "M173.434,147.517a3.746,3.746,0,0,0,2.308-5.131c-.962-2.119-24.125-52.147-71.407-73.764C57.029,47,4.844,62.611,2.647,63.287a3.744,3.744,0,0,0-2.31,5.131c.962,2.117,24.127,52.147,71.41,73.762,19.189,8.773,39.18,11.417,56.31,11.417a168.108,168.108,0,0,0,45.378-6.08m-98.573-12.15c-37.172-17-59.2-53.859-65.682-66.049,13.314-3.169,54.937-10.842,92.039,6.12,37.182,17,59.207,53.865,65.686,66.052-13.3,3.18-54.871,10.869-92.043-6.123",
    transform: "translate(0 62.946)",
    fill: "#f98309"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44469",
    "data-name": "Path 44469",
    d: "M104.49,209.715c1.357-1.9,33.227-47.251,33.227-104.072S105.847,3.474,104.49,1.571a3.748,3.748,0,0,0-6.1,0c-1.357,1.9-33.227,47.251-33.227,104.072S97.032,207.812,98.388,209.715a3.748,3.748,0,0,0,6.1,0m25.735-104.072c0,44.176-20.816,82.117-28.787,95.019-7.969-12.9-28.783-50.843-28.783-95.019s20.816-82.115,28.783-95.019c7.971,12.9,28.787,50.845,28.787,95.019",
    transform: "translate(71.699)",
    fill: "#f98309"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44470",
    "data-name": "Path 44470",
    d: "M186.716,142.388c48.092-21.608,71.657-71.632,72.636-73.753a3.744,3.744,0,0,0-2.317-5.156C254.8,62.8,201.748,47.2,153.657,68.809S82,140.441,81.02,142.561a3.747,3.747,0,0,0,2.317,5.158,173.638,173.638,0,0,0,46.132,6.074c17.416,0,37.741-2.642,57.247-11.4M156.727,75.644c37.81-16.988,80.22-9.29,93.751-6.12-6.618,12.226-29.027,49.043-66.833,66.031s-80.227,9.288-93.755,6.118c6.6-12.218,28.964-49.011,66.837-66.028",
    transform: "translate(88.769 63.162)",
    fill: "#f98309"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlower);
export default __webpack_public_path__ + "static/media/flower.f9e734eab1360e39c4337be3bae69eea.svg";
export { ForwardRef as ReactComponent };